import { defineAsyncComponent } from 'vue';

// Navigation-item is recursive. So we need the Wrapper to import it only once.
const LazyNavigationItem = defineAsyncComponent(() => import('./navigation-item.vue'));

export default LazyNavigationItem;
